import {
  useImpersonateDropdown,
  useImpersonationBanner,
} from "@client/ImpersonateContext";
import { ImpersonationSelector } from "@sfc/ui";
import { VenetianMaskIcon, XIcon } from "lucide-react";

export function ImpersonateAction() {
  const {
    show,
    viewAsUserId,
    underlyingUserId,
    userProfiles,
    items,
    viewAsUser,
  } = useImpersonateDropdown();
  if (!show) return null;
  const actualUser =
    underlyingUserId && userProfiles[underlyingUserId]
      ? {
          id: underlyingUserId,
          name: userProfiles[underlyingUserId].name,
          email: userProfiles[underlyingUserId].email ?? null,
          image: null,
        }
      : undefined;
  const effectiveUser = viewAsUserId
    ? userProfiles[viewAsUserId]
      ? {
          id: viewAsUserId,
          name: userProfiles[viewAsUserId].name,
          email: userProfiles[viewAsUserId].email ?? null,
          image: null,
        }
      : actualUser
    : actualUser;
  const users = items
    .filter((i) => !i.disabled)
    .map((i) => ({
      id: i.id,
      name: userProfiles[i.id]?.name ?? null,
      email: userProfiles[i.id]?.email ?? null,
      image: null,
      initials: i.initials,
    }));
  return (
    <ImpersonationSelector
      actualUser={actualUser}
      effectiveUser={effectiveUser}
      users={users}
      onImpersonate={(userId) => viewAsUser(userId ?? null)}
    />
  );
}

export function ImpersonationBanner() {
  const { isImpersonating, viewAsUserId, userProfiles, stopImpersonating } =
    useImpersonationBanner();
  if (!isImpersonating || !viewAsUserId) return null;
  const profile = userProfiles[viewAsUserId];
  const displayName = profile?.name ?? profile?.email ?? "Unknown user";
  return (
    <div className="bg-amber-500/15 border-b border-amber-500/30 px-4 py-1.5 flex items-center justify-center gap-2 text-sm">
      <VenetianMaskIcon className="size-4 text-amber-600 dark:text-amber-400 shrink-0" />
      <span>
        Viewing as <strong className="font-semibold">{displayName}</strong>
      </span>
      <button
        onClick={() => void stopImpersonating()}
        className="ml-1 p-0.5 rounded hover:bg-amber-500/20 text-amber-600 dark:text-amber-400"
      >
        <XIcon className="size-3.5" />
      </button>
    </div>
  );
}
